import { methodGet, methodPost, methodDelete, methodPatch, methodUploadPost } from './methods';
import { API_INFO } from '../constants';

export async function getRecentSales(query) {
  const url = API_INFO + `storehouse/pedidos/recent_sales/`;
  return methodGet(url, query);
}
export async function getRecentSalesNumber() {
  const url = API_INFO + `storehouse/pedidos/units_solds_last_week/`;
  return methodGet(url);
}
export async function getDetailOrder(id, query) {
  const url = API_INFO + `storehouse/orders/${id}/`;
  return methodGet(url, query);
}
export async function getDetailOrderProfile(id) {
  const url = API_INFO + `storehouse/orders/${id}`;
  return methodGet(url);
}
export async function deleteDetailOrder(id, query) {
  const url = API_INFO + `storehouse/orders/${id}/`;
  return methodDelete(url, query);
}
export async function createOrder(payload) {
  const url = API_INFO + `storehouse/orders/`;
  return methodPost(url, payload);
}
export async function editDetailOrder(payload, id) {
  const url = API_INFO + `storehouse/orders/${id}/`;
  return methodPatch(url, payload);
}

export async function getAllOrders(query) {
  const url = API_INFO + `storehouse/orders/?`;
  return methodGet(url, query);
}

export async function getMyOrders(query) {
  const url = API_INFO + `storehouse/orders/me/`;
  return methodGet(url, query);
}

export async function getMinYearOrder() {
  const url = API_INFO + `storehouse/orders/filters/`;
  return methodGet(url);
}

export async function getAllOrdersNotPaginated() {
  const url = API_INFO + `storehouse/orders/all-orders-not-paginated`;
  return methodGet(url);
}

export async function sendClaim(payload) {
  const url = API_INFO + 'storehouse/claims/';
  return methodPost(url, payload);
}
export async function getUserBoughtBooks() {
  const url = API_INFO + 'storehouse/orders/books_purchased_by_user/';
  return methodGet(url);
}
export async function getPurchaseCommissions(query) {
  const url = API_INFO + `storehouse/commissions/`;
  return methodGet(url, query);
}
export async function getCommissionsByCompany() {
  const url = API_INFO + `storehouse/commissions/commissions_by_company/`;
  return methodGet(url);
}

export async function updateCartSituationBankTransfer() {
  const url = API_INFO + `orders/order-utils/transfer-payment/`;
  return methodPost(url);
}

export async function getStatisticsForMonthYear(month, year) {
  const url = `${API_INFO}statistics/statistics/?year=${year}&month=${month}`;
  return methodGet(url);
}

export async function createReturn(payload) {
  const url = API_INFO + `storehouse/returns/`;
  return methodPost(url, payload);
}

export async function getMyOrdersWithLang(query, language) {
  const url = API_INFO + `storehouse/orders/me/`;
  return methodGet(url, query, language);
}

export async function validateGiftCard(payload) {
  const url = API_INFO + `ecommerce/carts/apply_coupon_payment/`;
  return methodGet(url, payload);
}

export async function updateArticleStatus(payload) {
  const url = API_INFO + 'storehouse/orders/update-article-status/';
  return methodUploadPost(url, payload);
}